import React from "react";
import Textarea from "../../ui/textarea";
import {useFormState} from "../../hooks/useFormState";
import Button from "../../ui/button";
import classes from "../account/AssignModal.module.css";
import {useTranslation} from "react-i18next";
import {TriggerDictionaryInput, TriggerDictionaryType} from "../../schema";
import Input from "../../ui/input";

type contentProps = React.ComponentProps<"div"> & {
  dict?: TriggerDictionaryType
  onSave?: (data: TriggerDictionaryInput) => void
  onDelete?: () => void
}

function TriggerDictionaryModalHeader() {
  const {t} = useTranslation();

  return <span>{t("components.AddMembersModal.AddMembersModalTitle")}</span>
}

 function TriggerDictionaryModalContent({dict, onSave, onDelete}: contentProps) {
  const {t} = useTranslation();

  const formState = useFormState<{
    name: string,
    phrases: string,
  }>({
    initialValues: {
      name: dict?.name ?? "",
      phrases: dict?.phrases ?? "",
    },

    preventDefault: true,

    onSubmit: (data) => {
      onSave && onSave(data);
    }
  });

  const submitDisabled = undefined

  return (
    <form className={classes.root} method="post" onSubmit={formState.submitHandler}>
      <>
        <p className={classes.helpText}>{t("components.TriggerDictionaryModal.nameHelpText")}</p>
        <Input
          className={classes.input}
          name="name"
          value={formState.values.name ?? ""}
          required
          maxLength={36}
          placeholder={t("components.TriggerDictionaryModal.namePlaceholder")}
          onChange={formState.changeHandler}
        />

        <p className={classes.helpText}>{t("components.TriggerDictionaryModal.phrasesHelpText")}</p>
        <Textarea
          className={classes.input}
          name="phrases"
          value={formState.values.phrases ?? ""}
          rows={8}
          required
          placeholder={t("components.TriggerDictionaryModal.phrasesPlaceholder")}
          onChange={formState.changeHandler}
        />
      </>

      <div className={classes.bottom}>
        <Button type="submit" color={submitDisabled ? "secondary" : "success"} disabled={submitDisabled}>
          {t("components.TriggerDictionaryModal.submit")}
        </Button>
        {dict && (
          <Button type="button" color="danger" onClick={onDelete}>
            {t("components.TriggerDictionaryModal.delete")}
          </Button>
        )}
      </div>
    </form>
  )
}

const TriggerDictionaryModal = {
  Header: TriggerDictionaryModalHeader,
  Content: TriggerDictionaryModalContent,
}

export default TriggerDictionaryModal;
